import { Mail } from "lucide-react";
import { Reveal } from "./Reveal";

export default function Contact() {
  return (
    <section id="contact" data-testid="contact-section" className="border-t border-white/10 px-6 py-32 md:py-44">
      <div className="mx-auto max-w-4xl text-center">
        <Reveal>
          <p data-testid="contact-eyebrow" className="mb-8 font-mono text-[11px] uppercase tracking-[0.5em] text-gold">
            Contact
          </p>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 data-testid="contact-heading" className="font-serif text-4xl font-light leading-tight text-neutral-100 sm:text-5xl lg:text-6xl">
            Begin a <em className="text-gold-light">conversation</em>
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mx-auto mt-8 max-w-md text-base font-light leading-relaxed text-neutral-400">
            For enquiries, collaborations, or press — we would love to hear from you.
          </p>
        </Reveal>
        <Reveal delay={0.3}>
          <a
            href="mailto:tabiessenceofstrength@gmail.com"
            data-testid="contact-email-link"
            className="group mt-12 inline-flex items-center gap-4 border-b border-gold/40 pb-3 transition-colors duration-500 hover:border-gold"
          >
            <Mail className="h-5 w-5 text-gold-light" strokeWidth={1.5} />
            <span className="font-serif text-2xl font-light italic text-neutral-100 transition-colors duration-500 group-hover:text-gold-light sm:text-3xl">
              tabiessenceofstrength@gmail.com
            </span>
          </a>
        </Reveal>
      </div>
    </section>
  );
}
